__turbopack_context__.v({
  "container": "BkDtLq_container",
  "desktopOnly": "BkDtLq_desktopOnly",
  "freeShipping": "BkDtLq_freeShipping",
  "messageSeller": "BkDtLq_messageSeller",
  "secondaryCta": "BkDtLq_secondaryCta",
  "secondaryCtaGroup": "BkDtLq_secondaryCtaGroup",
  "sellerInactiveDisclaimer": "BkDtLq_sellerInactiveDisclaimer",
});
